<template>
  <EditorNumberLottery v-if="isMergedLotteryPage && isNumberLottery" />
  <EditorDateLottery v-else-if="isMergedLotteryPage && isDateLottery" />
  <EditorPickLottery v-else-if="isMergedLotteryPage" />
  <ClientOnly v-else>
    <UnmergedLotteryEditor />
  </ClientOnly>
</template>

<script lang="ts" setup>
definePageMeta({
  isGameRoute: true,
  layout: false,
  middleware: ['age-verification', 'self-excluded', 'log-editor-usage'],
  tracking: { name: 'LotteryPlaySlipEditor' },
  validate: ({ params: { lotteryId } }) =>
    useLotteriesOfLicensedTerritory().doesExist(String(lotteryId)),
})

const lotteryId = String(useRoute().params.lotteryId)

const isMergedLotteryPage = useIsMergedLotteryPage(lotteryId)
const transformedLotteryId = getLotteryIdInCorrectCase(lotteryId)

if (!transformedLotteryId) throw create404Error()

const { isDateLottery, isNumberLottery } = useLotteryType(transformedLotteryId)

if (isMergedLotteryPage) useEditorCheckout(transformedLotteryId)
</script>
